import ajax from 'utils/request';
// 获取bundles列表
export function getBundles() {
    return ajax('GET', '/accounts/my/bundles');
}
//获取bundle详情
export function getBundleById(id) {
    return ajax('GET', '/bundles/'+id,null,true);
}
//创建bundle
export function createBundle(params) {
    return ajax('PUT', '/bundles',params);
}
//重新申请bundle
export function replaceBundle(id,params) {
    return ajax('POST', '/bundles/'+id+'/replace',params);
}

//解绑bundle
export function deleteBundle(id) {
    return ajax('DELETE', '/bundles/'+id);
}

//延期
export function postpontBundle(id,params){
    return ajax('POST', '/bundles/'+id,params);
}



// WEBPACK FOOTER //
// ./src/actions/bundle.js